export default __webpack_public_path__ + "static/032a-f62c76ea2f58f0c6f2c6cec0f396ffee.jpg";